import React, { useState } from 'react';

import { Button } from './Button';
import { PropertyMoreInfoActionModal, PropertyTourActionModal } from './modals';

export const PropertyInfoActions = ({
  mlsnum,
  user,
  tourRequestState = {},
  moreInfoRequestState = {},
  onRequestTour = () => {},
  onRequestMoreInfo = () => {},
  onPreApproval = () => {},
}) => {
  const [showTour, setShowTour] = useState(false);
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  return (
    <>
      <Button
        label="Tour"
        className="bg-primary2 w-3/12 items-center justify-center"
        labelStyle="text-white font-primary-bold text-base"
        onClick={() => setShowTour(true)}
      />
      <Button
        label="More Info"
        className="bg-primary2 w-3/12 items-center justify-center"
        labelStyle="text-white font-primary-bold text-base"
        onClick={() => setShowMoreInfo(true)}
      />
      <Button
        label="Get Pre-Approved"
        className="bg-yellow-600 w-3/12 items-center justify-center"
        labelStyle="text-white font-primary-bold text-base"
        onClick={() => onPreApproval(mlsnum)}
      />
      <PropertyTourActionModal
        visible={showTour}
        mlsnum={mlsnum}
        user={user}
        submitting={tourRequestState.loading}
        successKey={tourRequestState.successKey}
        onSubmit={onRequestTour}
        onClose={() => setShowTour(false)}
      />
      <PropertyMoreInfoActionModal
        visible={showMoreInfo}
        mlsnum={mlsnum}
        user={user}
        submitting={moreInfoRequestState.loading}
        successKey={moreInfoRequestState.successKey}
        onSubmit={onRequestMoreInfo}
        onClose={() => setShowMoreInfo(false)}
      />
    </>
  );
};
